import { isSameWeek, today } from "owa-datetime";
import { action, mutatorAction, orchestrator } from "satcheljs";
import { DateRangeType } from "@fluentui/date-time-utilities";
import { getDefaultWeekRange } from "../utils/getDefaultWeekRange";
import { getUserWeekStartDay } from "../utils/getUserWeekStartDay";
import { getCurrentDateRange, getStore, setCurrentDate, setCurrentDateRange } from "./Store";

import type { OwaDate } from "owa-datetime";
import type { DateRange } from "owa-datetime-utils";

/* eslint-disable-next-line owa-custom-rules/require-add-identifier-to-mutator-action-variables -- (https://aka.ms/OWALintWiki)
 * Mutator action variables should end with 'Mutator' so that we can more easily identify potential misuses of it.
 *	> Please add 'Mutator' substring add the end of the mutator action variable name. */
const initializeWeekPickerViewState: () => void = mutatorAction("initializeWeekPickerViewState", (): void => {
    getStore().currentDate = today();
    getStore().currentDateRange = getDefaultWeekRange();
    getStore().currentDateRangeType = DateRangeType.WorkWeek;
});

function isTodayInCurrentDateRange(): boolean {
    return isSameWeek(getCurrentDateRange().start, today(), getUserWeekStartDay());
}

/**
 * Action to update current date
 */
export interface UpdateCurrentDateActionMessage {
    date: OwaDate;
}
const updateCurrentDate: (date: OwaDate) => UpdateCurrentDateActionMessage = action("updateCurrentDate", (date: OwaDate): UpdateCurrentDateActionMessage => ({
    date,
}));

orchestrator(updateCurrentDate, ({ date }) => setCurrentDate(date));

/**
 * Action to update current date range
 */
export interface UpdateCurrentDateRangeActionMessage {
    dateRange: DateRange;
}
const updateCurrentDateRange: (dateRange: DateRange) => UpdateCurrentDateRangeActionMessage = action("updateCurrentDateRange", (dateRange: DateRange): UpdateCurrentDateRangeActionMessage => ({
    dateRange,
}));

orchestrator(updateCurrentDateRange, ({ dateRange }) => setCurrentDateRange(dateRange));

export { initializeWeekPickerViewState, isTodayInCurrentDateRange, updateCurrentDateRange, updateCurrentDate, };
